import { Card } from 'components'
import { useLoading, useModal } from 'hooks'
import {
  EfetivoLogicoServices,
  EffectiveData,
  ResGetAllContracts
} from 'services/Supplier/LogicalEffective'
import { COLORS, FORMAT, SPACING } from 'utils'

import { changeTabProps } from '../LogicalEffectiveRegister'
import { DadosEmpresa, DadosColaborador } from './components'

export interface RegisterEffectivesProps {
  contractData: ResGetAllContracts
  handleChangeTab: (props: changeTabProps) => void
}

export interface errorMessageObject {
  message: string
  name: string
  stack: string
}

const RegisterEffectives = ({
  contractData,
  handleChangeTab
}: RegisterEffectivesProps) => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const handleCancel = () => {
    handleChangeTab({
      contractData: null,
      newValue: 0
    })
  }

  const handleAddNewColaborator = async (data: EffectiveData) => {
    setLoading('loading')

    const requestQuery: EffectiveData = {
      cdCep: FORMAT.unMask(data.cdCep) || undefined,
      cdCnh: FORMAT.unMask(data.cdCnh),
      cdContrato: contractData.cdContrato,
      cdCpf: FORMAT.unMask(data.cdCpf),
      cdCtps: FORMAT.unMask(data.cdCtps) || undefined,
      cdDocumento: FORMAT.unMask(data.cdDocumento) || undefined,
      cdPis: FORMAT.unMask(data.cdPis) || undefined,
      cdSerieCtps: data.cdSerieCtps || undefined,
      dtNascimento: new Date(data.dtNascimento),
      flUsaRefeitorio: data.usaRefeitorio,
      idContrato: contractData.idContrato || data.idContrato,
      idEfetivoLogico: data?.idEfetivoLogico || 0,
      nmColaborador: data.nmColaborador,
      nuNumero: Number(data.nuNumero) || 0,
      sgEstadoCtps: data.sgEstadoCtps || undefined,
      sgEstadoDocto: data.sgEstadoDocto || undefined,
      sgEstadoEnd: data.sgEstadoEnd || undefined,
      sgGenero: data.sgGenero,
      txBairro: data.txBairro || undefined,
      txCidade: data.txCidade || undefined,
      txComplemento: data.txComplemento,
      txEmissorDocto: data.txEmissorDocto || undefined,
      txEndereco: data.txEndereco || undefined,
      txFiliacaoMae: data.txFiliacaoMae,
      txFiliacaoPai: data.txFiliacaoPai,
      txFuncao: data.txFuncao,
      txLocalAcesso: data.txLocalAcesso,
      txMatricula: '',
      txNacionalidade: data.txNacionalidade,
      txNaturalidade: data.txNaturalidade
    }

    try {
      const response = await EfetivoLogicoServices().createEfetivoLogico(
        requestQuery
      )

      if (response.status !== 200) {
        throw new Error(response.data?.detail)
      }

      showModal({
        hideButtonCancel: true,
        message: 'Colaborador cadastrado com sucesso!',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })

      setLoading('idle')
      handleChangeTab({
        contractData: contractData,
        newValue: 0
      })
    } catch (e: any) {
      showModal({
        hideButtonCancel: true,
        message: e?.message || 'Erro ao cadastrar colaborador',
        txtButtonConfirm: 'Fechar',
        type: e?.response?.data?.title ? 'alert' : 'error'
      })
      setLoading('idle')
    }
  }

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      {contractData && <DadosEmpresa contractData={contractData} />}

      <DadosColaborador
        handleAddNewColaborator={handleAddNewColaborator}
        handleCancel={handleCancel}
      />
    </Card>
  )
}

export default RegisterEffectives
